import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { WeblinkRoutingModule } from './weblink-routing.module';
import { WeblinkFaultListComponent } from './weblink-fault-list/weblink-fault-list.component';
import { WeblinkMainComponent } from './weblink-main/weblink-main.component';
import { WeblinkFaultService } from './shared/weblink-fault.service';
import { WeblinkTokenService } from './shared/weblink-token.service';
import { WeblinkUserService } from './shared/weblink-user.service';

import { CanNavigateToWeblinkGuard } from './shared/can-navigate-to-weblink.guard';
import { CanDeactivateWeblinkGuard } from './shared/can-deactivate-weblink.guard';
import { WeblinkFaultDetailComponent } from './weblink-fault-detail/weblink-fault-detail.component';
import { WeblinkFaultEditComponent } from './weblink-fault-edit/weblink-fault-edit.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { WeblinkHeaderComponent } from './weblink-header/weblink-header.component';
import { WeblinkLoaderComponent } from './weblink-loader/weblink-loader.component';
import { WeblinkFaultTileComponent } from './weblink-fault-tile/weblink-fault-tile.component';
import { HighlightPipe } from './shared/highlight.pipe';
import { FormatPipe } from './shared/format.pipe';
import { WeblinkFooterComponent } from './weblink-footer/weblink-footer.component';
import { WeblinkMenuComponent } from './weblink-menu/weblink-menu.component';
import { WeblinkActivityViewComponent } from './weblink-activity-view/weblink-activity-view.component';
import { WeblinkLoginComponent } from './weblink-login/weblink-login.component';
import { WeblinkAttachmentListComponent } from './weblink-attachment-list/weblink-attachment-list.component';
import { ResponsiveComponent } from './shared/responsive/responsive.component';
import { MediaQueryService } from './shared/responsive/services/media-query.service';
import { AnimationBuilder } from '@angular/animations';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WeblinkRoutingModule,
    TranslateModule.forChild(),
    BsDropdownModule.forRoot(),
  ],
  declarations: [ WeblinkFaultListComponent, WeblinkMainComponent, WeblinkFaultDetailComponent, WeblinkFaultEditComponent,
    WeblinkHeaderComponent,
    WeblinkLoaderComponent,
    WeblinkFaultTileComponent,
    HighlightPipe,
    FormatPipe,
    WeblinkFooterComponent,
    WeblinkMenuComponent,
    WeblinkActivityViewComponent,
    WeblinkLoginComponent,
    WeblinkAttachmentListComponent,
    ResponsiveComponent],
  providers: [ WeblinkFaultService, WeblinkTokenService,WeblinkUserService, CanNavigateToWeblinkGuard, CanDeactivateWeblinkGuard,MediaQueryService ]
})
export class WeblinkModule { }
